import { SvgIcon } from '@mui/material';

export function ReviewIcon(props) {
	return (
		<SvgIcon
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			{...props}
		>
			<path
				d="M9.075 14.25L12 12.475L14.925 14.25L14.15 10.925L16.75 8.675L13.325 8.4L12 5.25L10.675 8.4L7.25 8.675L9.85 10.925L9.075 14.25ZM2 22V4C2 3.45 2.19583 2.97917 2.5875 2.5875C2.97917 2.19583 3.45 2 4 2H20C20.55 2 21.0208 2.19583 21.4125 2.5875C21.8042 2.97917 22 3.45 22 4V16C22 16.55 21.8042 17.0208 21.4125 17.4125C21.0208 17.8042 20.55 18 20 18H6L2 22ZM5.15 16H20V4H4V17.125L5.15 16Z"
				fill="currentColor"
			/>
		</SvgIcon>
	);
}
